export const shouldShowAddPaymentButton = (breakpoint: string) => breakpoint !== 'large' && breakpoint !== 'medium';
